<template>
  <div class="scoreNumberRating">
    <div
      class="scoreNumberRating__numberContainer d-flex justify-content-center"
    >
      <template v-for="(number, index) in numbers">
        <div
          @click="selectNumber(number)"
          class="scoreNumberRating__number d-flex justify-content-center align-items-center"
          :class="{ selected: number == scoreResult }"
          :key="index"
        >
          <span>{{ number }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    targetRating: {
      default: 10,
    },
    data: {},
  },

  data() {
    return {
      scoreResult: 0,
    };
  },

  methods: {
    selectNumber(number) {
      this.scoreResult = number;
      this.$emit('changeValue', {
        field_type: 'score_number',
        value: number,
        field_id: this.data.id,
      });
    },
  },

  computed: {
    numbers() {
      let count = 0;
      while (count < this.targetRating) {
        count += 1;
      }

      return count;
    },
  },
};
</script>

<style lang="scss">
$backgroundHoverColor: #0496D8;

.scoreNumberRating {
  &__numberContainer {
    flex-wrap: wrap;
  }

  &__number {
    margin: 3px;
    border: 1px solid #0496d8;
    border-radius: 100%;
    width: 40px;
    height: 40px;
    cursor: pointer;

    > span {
      font-weight: bold;
    }
    &:hover {
      border-color: $backgroundHoverColor;
      background-color: $backgroundHoverColor;
    }
  }

  .selected {
    border-color: $backgroundHoverColor;
    background-color: $backgroundHoverColor;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/rating/fields/fieldScoreNumber.vue